import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  Box,
  MenuItem,
  Select,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { useTheme } from "@mui/material/styles";
import { useBoolean } from "src/hooks/use-boolean";
import CreateCampaignModal from "./create-campaign-modal";

export default function RouteModal({ title, data, campaigns, open, onClose, ...other }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const campaignNames = campaigns?.map(c => c.name)

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);

  const openCreateModal = useBoolean();

  const handleClose = () => {
    setDropdownOpen(false);
    setSelectedCampaign("");
    onClose();
  };

  useEffect(()=>{
    console.log(campaignNames?.[0],'kjashdkajsh')
    setSelectedCampaign(campaignNames?.[0] || null)
  },[])

  const handleAddToCampaignClick = () => {
    setDropdownOpen(true);
    setSelectedCampaign(campaignNames?.[0] || null);
  };

  const handleCampaignSelect = (event) => {
    setSelectedCampaign(event.target.value);
  };

  const handleDeselectCampaign = () => {
    setSelectedCampaign("");
    setDropdownOpen(false);
  };

  const handleSubmit = () => {
    console.log("Submitting campaign:", selectedCampaign);
    // handleClose();
  };

  const handleOpenCreateModal = () => {
    openCreateModal.onTrue();
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} {...other}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: isMobile ? 2 : 2 }}>
        <Typography variant={isMobile ? "h6" : "h5"}>{title}</Typography>
        <IconButton onClick={handleClose} sx={{ color: "gray" }}>
          <GridCloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ p: isMobile ? 1 : 2 }}>
          {[
            { label: "City", value: `New York` },
            { label: "State", value: `NY` },
            { label: "Residential", value: `254` },
            { label: "Business", value: `220` },
            { label: "Avg. Income", value: `$${data?.income}` },
            { label: "Total House", value: data?.totalHouse },
            { label: "Male", value: data?.male },
            { label: "Avg. Age", value: `30.8` },
          ].map((item, index) => (
            <Grid key={index} item xs={12} sm={6}>
              <Box display="flex" justifyContent="space-between">
                <Typography color="gray">{item.label}:</Typography>
                <Typography fontWeight="bold">{item.value}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          gap: 1,
          p: 2,
        }}
      >
        {isDropdownOpen ? (
          <Select
            value={selectedCampaign}
            onChange={handleCampaignSelect}
            displayEmpty
            sx={{
              minWidth: 200,
              fontSize: "14px",
              height: "36px",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <MenuItem value="" onClick={handleDeselectCampaign}>
              Deselect & Create New
            </MenuItem>
            {campaignNames.map((campaign) => (
              <MenuItem key={campaign} value={campaign}>
                {campaign}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <Button fullWidth={isMobile} variant="contained" onClick={handleAddToCampaignClick}>
            Add to Campaign
          </Button>
        )}

        <Button
          fullWidth={isMobile}
          variant="contained"
          style={{marginLeft:"0px"}}
          onClick={() => {
            if (isDropdownOpen && selectedCampaign) {
              handleSubmit();
            } else {
              handleOpenCreateModal();
            }
          }}
        >
          {isDropdownOpen && selectedCampaign ? "Submit" : "Create New    "}
        </Button>
      </DialogActions>

      <CreateCampaignModal open={openCreateModal.value} onClose={openCreateModal.onFalse} />
    </Dialog>
  );
}

RouteModal.propTypes = {
  data: PropTypes.shape({
    income: PropTypes.string,
    totalHouse: PropTypes.number,
    male: PropTypes.number,
    female: PropTypes.number,
  }),
  campaigns: PropTypes.arrayOf(PropTypes.string),
  onClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
};
